import Select, { components as Components } from "react-select";
import Creatable from "react-select/creatable";
import styled from "styled-components";

const ValuesContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
`;

const Value = styled.div`
  padding: 0.3rem 0.5rem 0.3rem 0.5rem;
  margin: 0 0.55rem 0.55rem 0;
  font-size: 0.75rem;
  color: white;
  background-color: #365561;
  user-select: none;
  border-radius: 10px;
`;

const XButton = styled.button`
  font-size: 0.75rem;
  all: unset;
  margin-left: 0.3rem;
  color: white;
  transition: fill 0.15s ease-in-out;
  cursor: pointer;
`;

const OptionsOutsideSelect = (props) => {
  const { isMulti, value, onChange } = props;

  const handleRemoveValue = (e) => {
    if (!onChange) return;
    const { name: buttonName } = e.currentTarget;
    const removedValue = value.find((val) => val.value === buttonName);
    if (!removedValue) return;
    onChange(
      value.filter((val) => val.value !== buttonName),
      { name: buttonName, action: "remove-value", removedValue }
    );
  };

  return (
    <div>
      <ValuesContainer>
        {value
          ? value.map((val) => (
              <Value key={val.value}>
                {val.label}
                <XButton name={val.value} onClick={handleRemoveValue}>
                  ✕
                </XButton>
              </Value>
            ))
          : null}
      </ValuesContainer>
      <Creatable {...props} controlShouldRenderValue={!isMulti} />
    </div>
  );
};

export default OptionsOutsideSelect;
